

























































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js'
import axios from 'axios'

// You'll need to first install the package: 
// npm install @stripe/stripe-js --save

@Component
export default class StripeElementCardPayComponent extends Vue {
  @Prop({ default: "" })
  mail!: string

  @Prop({ default: 0 })
  purchasePrice!: number

  @Prop({ default: "カードを変更する" })
  btn!: string

  @Prop({ default: "Edbase[エドベース]" })
  title!: string

  @Prop({ default: "" })
  description!: string

  @Prop({ required: true })
  premiumServiceId!: string

  @Prop({ required: true })
  user_id!: string

  @Prop({ default: "" })
  pricePlanId!: string

  @Prop({ default: "" })
  couponCode!: string

  @Prop({ default: "1" })
  installmentCount!: string

  @Prop({ required: true })
  cardComplete!: (paymentIntentId: string) => void

  @Prop({ default: null })
  changeFromSubscriptionId!: string

  @Prop({ default: "" })
  type_change!: string

  // Typed properties for Stripe
  showModal = false
  stripe: Stripe | null = null
  elements: StripeElements | null = null
  cardElement: StripeCardElement | null = null
  isCardComplete = false
  cardError: string = ''
  isProcessing = false
  stripePromise: Promise<Stripe | null> | null = null

  // card details
  cardBrand: string = '';
  cardLast4: string = '';
  cardExpMonth: number | null = null;
  cardExpYear: number | null = null;

  mounted() {
    this.initStripePromise()
  }

  // Initialize Stripe with the official package
  initStripePromise() {
    // Try to get key from window global (set by Rails)
    const stripeKey = typeof window !== 'undefined' && 'stripe_publishable_key' in window 
      ? (window as any).stripe_publishable_key
      : 'pk_test_51JTdp5BLyLEisqmg7jI53Eu2dMWbssUIo4Bcs69zI5ZybYLbAVJCwT5IuIYC6I9qzsIAFtyhnH1ReufLLPoBJMbM001cxeSv9D';
    
    // Create the Stripe promise for lazy loading
    this.stripePromise = loadStripe(stripeKey);
    
    console.log('Stripe promise initialized with key:', stripeKey.substring(0, 8) + '...');
  }

  @Watch('showModal')
  async onModalVisibilityChanged(isVisible: boolean) {
    if (isVisible) {
      // Wait for DOM to update then initialize Stripe elements
      this.$nextTick(async () => {
        await this.initializeStripeElements()
      })
    } else {
      this.unmountCardElement()
    }
  }

  // Open payment modal
  openPaymentModal() {
    this.showModal = true
  }

  // Close payment modal
  closeModal() {
    this.showModal = false
  }

  // Initialize Stripe elements
  async initializeStripeElements() {
    try {
      if (!this.stripe) {
        // Load Stripe instance from promise
        this.stripe = await this.stripePromise;
        
        if (!this.stripe) {
          throw new Error('Stripe failed to initialize');
        }
      }
      
      // Create elements instance
      this.elements = this.stripe.elements();
      
      // Mount the card element
      this.mountCardElement();
    } catch (error) {
      console.error('Error initializing Stripe elements:', error);
      this.cardError = error instanceof Error ? error.message : 'Stripe initialization failed';
    }
  }

  // Mount card element
  mountCardElement() {
    if (!this.elements) {
      console.error('Stripe Elements not initialized');
      return;
    }

    try {
      // Create card element
      this.cardElement = this.elements.create('card', {
        style: {
          base: {
            fontSize: '16px',
            color: '#32325d',
            fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
            '::placeholder': { color: '#aab7c4' }
          },
          invalid: {
            color: '#dc3545',
            iconColor: '#dc3545'
          }
        },
        hidePostalCode: true
      });

      // Mount to DOM
      const mountPoint = document.getElementById('stripe-card-element');
      if (mountPoint) {
        this.cardElement.mount('#stripe-card-element');

        // Listen for card input changes
        this.cardElement.on('change', (event) => {
          this.isCardComplete = event.complete;
          this.cardError = event.error ? event.error.message : '';
        });
      } else {
        console.error('Card element mount point not found');
      }
    } catch (error) {
      console.error('Error mounting card element:', error);
      this.cardError = error instanceof Error ? error.message : 'Failed to load card input';
    }
  }

  // Unmount card element
  unmountCardElement() {
    if (this.cardElement) {
      this.cardElement.unmount();
      this.cardElement = null;
    }
  }

  // Format number with commas
  numberWithCommas(x: number): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Handle payment submission
  async handlePaymentSubmission() {
    if (!this.stripe || !this.cardElement || this.isProcessing) {
      return;
    }

    this.isProcessing = true;
    this.cardError = '';

    try {
      // Step 1: Create a PaymentMethod
      const { paymentMethod, error: paymentMethodError } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardElement,
        billing_details: {
          name: this.title,
          email: this.mail
        }
      });

      if (paymentMethodError) {
        throw new Error(paymentMethodError.message);
      }

      // Validate premium service ID exists
      if (!this.premiumServiceId) {
        throw new Error('Missing premium service ID. Cannot proceed with payment.');
      }

      // Step 2: Create payment intent for premium service subscription
      const formData = {
        premium_service_id: this.premiumServiceId,
        price_plan_id: this.pricePlanId || "",
        coupon_code: this.couponCode || "",
        installment_count: this.installmentCount || "",
        amount: this.purchasePrice,
        payment_method_id: paymentMethod.id,
        action_type: "change_card",
        type_change: this.type_change || "",
        change_from_subscription_id: this.changeFromSubscriptionId || "",
        name: this.title || ""
      };

      console.log('Submitting payment with data:', {
        ...formData,
        payment_method_id: 'REDACTED'  // Don't log the actual payment method ID
      });

      // Get CSRF token from meta tag
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      // Make the request with proper URL
      const response = await fetch(`/premium_services/${this.premiumServiceId}/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'サーバーエラーが発生しました。もう一度お試しください。');
      }

      const data = await response.json();

      console.log('Payment response data:', data);
      // Step 3: Handle 3D Secure authentication if needed
      if (data.client_secret) {
        const { setupIntent, error } = await this.stripe.confirmCardSetup(data.client_secret, {
          payment_method: paymentMethod.id
        });

        if (error) {
          this.cardError = error.message;
          return;
        } else {
          this.cardBrand = paymentMethod.card.brand;
          this.cardLast4 = paymentMethod.card.last4;
          this.cardExpMonth = paymentMethod.card.exp_month;
          this.cardExpYear = paymentMethod.card.exp_year;

          console.log('Payment Method Card Details:', {
            brand: this.cardBrand,
            last4: this.cardLast4,
            exp_month: this.cardExpMonth,
            exp_year: this.cardExpYear,
          });
        }

        console.log('Thẻ đã xác minh và lưu thành công');

        this.$emit('payment-method-cart-setup', setupIntent.payment_method);
        this.$emit('client-secret-cart-setup', data.client_secret);
        this.$emit('subscription-id-cart-setup', data.subscription_id);

        this.$emit('card-details', {
          brand: this.cardBrand,
          last4: this.cardLast4,
          exp_month: this.cardExpMonth,
          exp_year: this.cardExpYear
        });

        // Payment successful after 3D Secure authentication
        this.paymentSuccessful(setupIntent?.id || '');
      } else if (data.success) {
        // No 3D Secure needed, payment was successful
        this.paymentSuccessful(data.subscription_id || data.payment_intent_id);
      } else if (data.error) {
        throw new Error(data.error);
      } else {
        this.paymentSuccessful(data.subscription_id);
      }
    } catch (error) {
      // Type check for error.message
      let errorMessage = 'お支払い処理中にエラーが発生しました。もう一度お試しください。';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'object' && error !== null && 'message' in error) {
        errorMessage = (error as any).message;
      }

      this.cardError = errorMessage;
      this.isProcessing = false;
    }
  }

  // Handle successful payment
  paymentSuccessful(paymentIntentId: string) {
    this.isProcessing = false;
    this.showModal = false;

    // Call the provided callback with the payment intent ID
    // this.cardComplete(paymentIntentId);
  }
}
